<mat-toolbar>
  Contenedores - Tipos
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Recargar datos" (click)="ngOnInit()"><mat-icon color="primary">refresh</mat-icon></button>
  <button mat-button [matMenuTriggerFor]="beforeMenu"><mat-icon color="primary">menu</mat-icon></button>
  <mat-menu #beforeMenu="matMenu" xPosition="before">
    <button mat-menu-item (click)="newTipoContenedor()"><mat-icon color="primary">add_circle_outline</mat-icon> Añadir tipo</button>
    <button mat-menu-item routerLink="/contenedores-adm"><mat-icon color="primary">inventory_2</mat-icon> Contenedores</button>
    <button mat-menu-item (click)="saveExcel()"><mat-icon color="primary">description</mat-icon> Exportar tabla</button>
  </mat-menu>
</mat-toolbar>

@if (showProgressBar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="pageContent">
  <mat-form-field  class='buscarInput'>
    <mat-label>Buscar</mat-label>
    <input matInput type="text" [(ngModel)]="filter" placeholder="" (keyup)="applyFilter($event)">
  </mat-form-field>
  <div class='tableBlock'>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef > </th>
        <td mat-cell *matCellDef="let element" class='miniCell'>
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon matTooltip="Acciones">more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editarTipoContenedor(element.id)">
              <mat-icon color="primary">create</mat-icon>
              <span>Modificar</span>
            </button>
            <button mat-menu-item (click)="deleteTipoContenedor(element.id)">
              <mat-icon color="primary">delete</mat-icon>
              <span>Eliminar</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Nombre </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.nombre}} </td>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="emptyCell" colspan="5">No existen tipos...<br> <button mat-stroked-button (click)="newTipoContenedor()">Crear tipo</button></td>
      </tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [pageSize]="25" [pageSizeOptions]="pages" showFirstLastButtons></mat-paginator>
</div>
